module.exports = function() {
    const resizeMorePersonas = function() {
        const $morePersonasElement = $('.careers-persona-detail-more-personas');
        if ($morePersonasElement.length) {
            const $lastPersona = $morePersonasElement.find('.careers-persona-detail-more-personas-persona').last();
            var newHeight = $lastPersona.outerHeight() + $lastPersona.position().top + 8;

            if (ICF.Utils.Breakpoints.IsMobile()) {
                newHeight += 24;
            }

            $morePersonasElement.height(newHeight);
        }
    }

    resizeMorePersonas();
    setTimeout(resizeMorePersonas, 100);
    $(window).resize(resizeMorePersonas);

    $('.careers-persona-detail-header-expand-button').click(function () {
        $(this).toggleClass('careers-persona-detail-header-expand-button-active');
        $('.careers-persona-detail-more-personas').toggleClass('careers-persona-detail-more-personas-open');
    });
};